/**
 * UUID v4 regex (lowercase hex, 8-4-4-4-12).
 * Also accepts uppercase for safety.
 */
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Returns true if value looks like a valid UUID string. */
export function isUuid(value: unknown): value is string {
  return typeof value === "string" && UUID_RE.test(value);
}

/**
 * Normalizes a value intended for an `entity_id uuid` column.
 * Returns the value if it's a valid UUID string, otherwise null.
 *
 * Use this before any insert to system_events / audit_log / email_outbox
 * to prevent "column entity_id is of type uuid but expression is of type text" errors.
 */
export function normalizeEntityId(value: unknown): string | null {
  return isUuid(value) ? value : null;
}
